var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('apexchart',{attrs:{"type":"area","height":"100%","options":_vm.chart.chartOptions,"series":_vm.chart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }